import { Button, Popover } from "antd";
import { LuUserCircle } from "react-icons/lu";
const ProfileModal = (props: any) => {
  const Logout = () => {
    props?.logOut();
  };

  const ViewProfile = () => {
    if (props?.auth) return null;
    else {
      props.open();
    }
  };

  return props?.auth ? (
    <Popover
      placement="bottomRight"
      arrow={false}
      content={
        <div className="ProfileItem_box1">
          <LuUserCircle size={45} color="gray" />
          <div className="ProfileItem_txt1">
            {props?.user?.full_name
              ? props?.user?.full_name
              : props?.user?.email}
          </div>
          {/* <div
            className={styles.ProfileItem_txt2}
            onClick={() => rout.push(`/profile`)}
          >
            View Profile
          </div> */}
          <Button block onClick={() => Logout()} danger>
            Logout
          </Button>
        </div>
      }
      trigger="click"
    >
      <div className="Header_Icons2">
        <LuUserCircle size={27} color="#b72c6f" onClick={() => ViewProfile()} />
      </div>
    </Popover>
  ) : (
    <div className="Header_Icons2">
      <LuUserCircle size={27} color={"grey"} onClick={() => ViewProfile()} />
    </div>
  );
};

export default ProfileModal;
